/* eslint-disable lingui/text-restrictions */

import { t } from "@lingui/macro";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

type PromptResponse = {
  message?: string | number;
};

const PROMPT = `You are an AI writing assistant specialized in writing copy for resumes.
Do not return anything else except the revised text. It should not begin with a newline. It should not have any prefix or suffix text.
Rewrite the following text as concise resume bullet points in the same language as the input.
Return one bullet per line. Keep each bullet specific, results-oriented, and free of paragraph formatting.

Text: """{input}"""

Revised Text: """`;

export const requestPrompt = async (data: string) => {
  const response = await axios.post<PromptResponse, AxiosResponse<PromptResponse>>(
    "/auth/requestPrompt",
    { prompt: data },
  );

  return response.data;
};

export const convertToBullets = async (text: string) => {
  const prompt = PROMPT.replace("{input}", text);
  const result = await requestPrompt(prompt);

  if (result.message === 0) {
    throw new Error(t`OpenAI did not return any choices for your text.`);
  }

  return typeof result.message === "string" ? result.message : text;
};
